import { render, staticRenderFns } from "./RequestPayout.vue?vue&type=template&id=0b80ff51&"
import script from "./RequestPayout.vue?vue&type=script&lang=js&"
export * from "./RequestPayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports